import type { ReactElement, ReactNode } from 'react';
import { cn } from '../lib/utils';

export interface CenteredLayoutProps {
  readonly title: string;
  readonly description?: string;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
  readonly className?: string;
}

/** 로그인 · 회원가입 등 단일 카드 화면용 레이아웃. */
export const CenteredLayout = ({
  title,
  description,
  children,
  footer,
  className,
}: CenteredLayoutProps): ReactElement => (
  <div className={cn('flex min-h-dvh items-center justify-center bg-muted p-4', className)}>
    <section className="w-full max-w-sm rounded-xl bg-card p-8">
      <header className="mb-6 flex flex-col gap-1">
        <h1 className="font-display text-2xl font-extrabold text-card-foreground">{title}</h1>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </header>

      {children}

      {footer ? <footer className="mt-6 text-center text-sm">{footer}</footer> : null}
    </section>
  </div>
);
